// Authentication service
import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add token to requests automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('as_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface LoginResponse {
  token: string
  account: {
    id: string
    email: string
    displayName: string | null
  }
}

export interface User {
  id: string
  email: string
  displayName: string | null
  createdAt: string
}

export const authService = {
  /**
   * Login with Apple ID token
   */
  async loginWithApple(idToken: string | undefined, code?: string, user?: any): Promise<LoginResponse> {
    const response = await api.post('/auth/apple', {
      id_token: idToken,
      code,
      user,
    })
    return response.data
  },

  /**
   * Login with Google authorization code
   */
  async loginWithGoogle(code: string): Promise<LoginResponse> {
    const response = await api.post('/auth/google', {
      code,
    })
    return response.data
  },

  /**
   * Get current authenticated user
   */
  async getCurrentUser(token: string): Promise<User> {
    const response = await api.get('/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  },

  /**
   * Logout (client-side only)
   */
  logout() {
    localStorage.removeItem('as_token')
  },
}

export default api
